var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconColorBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.921724 15.0157C0.85725 14.985 0.8031 14.9362 0.765874 14.8753C0.728648 14.8144 0.709956 14.7439 0.712076 14.6725C0.714196 14.6012 0.737037 14.5319 0.777814 14.4733C0.818591 14.4147 0.875542 14.3692 0.941724 14.3424C2.69439 13.6324 2.12906 11.6344 2.65039 10.5664C2.95629 9.94912 3.49295 9.47712 4.14423 9.25254C4.79552 9.02795 5.50904 9.06886 6.13039 9.3664C10.0431 11.2777 5.38572 17.1404 0.921724 15.0157Z",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25987 9.40132L15.1119 1.99066C15.2607 1.81081 15.334 1.58028 15.3163 1.34753C15.2987 1.11477 15.1915 0.897918 15.0173 0.742541C14.8431 0.587164 14.6155 0.505366 14.3822 0.514339C14.149 0.523312 13.9283 0.622358 13.7665 0.790658L7.17188 7.36799",
    stroke: "#7E898F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconColorBrush);
export default __webpack_public_path__ + "static/media/streamline-icon-color-brush.d5f9a40da85b3396a4f4dbc58c8301c2.svg";
export { ForwardRef as ReactComponent };